<template>
  <div class="widget-investing-wrap">
    <iframe
      class="widget-investing-iframe"
      src="https://br.widgets.investing.com/live-currency-cross-rates?theme=darkTheme&hideTitle=false&roundedCorners=false&cols=bid,ask&pairs=1617,2103"
      width="100%"
      height="200"
      frameborder="0"
      allowtransparency="true"
      marginwidth="0"
      marginheight="0"
    ></iframe>
    <!-- <iframe
      src="https://br.widgets.investing.com/live-currency-cross-rates?theme=darkTheme&hideTitle=false&roundedCorners=false&cols=bid,ask&pairs=1617,2103"
      width="100%"
      height="200"
      frameborder="0"
      allowtransparency="true"
      marginwidth="0"
      marginheight="0"
    >
    </iframe> -->
  </div>
</template>

<script>
export default {
  computed: {
    weather() {
      return this.$store.state.weather;
    },
  },
  created() {
    this.$store.dispatch("updateWeather");
  },
};
</script>

<style lang="scss" scoped>
.widget-investing-wrap {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 13px;
}
.widget-investing-iframe {
  max-width: 479px;
  height: 212px;
}
@media screen and (max-width: 400px) {
  .widget-investing-wrap {
    padding: 0;
  }
  .widget-investing-iframe {
    height: 270px;
  }
}
</style>
